<template>
  <nav class="c-stepList">
    <div
      v-for="(item, index) in items"
      :key="`${item.title}-${index}`"
      :class="[
        'c-stepList__item',
        { 'c-stepList__item--active': itemPosition(item) === 0 },
        { 'c-stepList__item--done': itemPosition(item) < 0 },
      ]"
    >
      <router-link
        :to="item.route"
        :disabled="!!item.disabled"
        class="c-stepList__item-link d-flex align-center"
      >
        <div class="c-stepList__num mr-4">{{ index + 1 }}</div>
        <div class="c-stepList__text">{{ item.title }}</div>
      </router-link>

      <template v-if="item.submenu.length > 0">
        <div class="c-stepList__submenu">
          <router-link
            v-for="(submenuItem, subIndex) in item.submenu"
            :to="submenuItem.route"
            :key="`${submenuItem.title}-${subIndex}`"
            :class="[
              'c-stepList__submenu-item',
              { 'is--active': subitemPosition(submenuItem) === 0 },
            ]"
          >
            <div>
              {{ submenuItem.title }}
            </div>
          </router-link>
        </div>
      </template>
    </div>
  </nav>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true },
  },
  computed: {
    currentItem() {
      // console.log(
      //   "changed",
      //   this.items.find(i => this.$route.path.includes(i.route))
      // )
      return this.items.find(i => this.$route.path.includes(i.route))
    },
    currentSubitem() {
      return this.currentItem?.submenu.find(i =>
        this.$route.path.includes(i.route)
      )
    },
  },
  methods: {
    /**
     * Determines position of underlying menu item
     * relative to currently active menu item:
     *
     * - Positive number means it's ahead of active item (= not completed)
     * - Negative number means it's before active item (= completed)
     * - Zero means it's active item itself (= currently opened)
     */
    itemPosition(item) {
      if (!this.currentItem) {
        return Infinity
      }
      return this.items.indexOf(item) - this.items.indexOf(this.currentItem)
    },

    /**
     * Analogous to `itemPosition` but for subitems.
     */
    subitemPosition(subitem) {
      if (!this.currentItem || !this.currentSubitem) {
        return Infinity
      }
      return (
        this.currentItem.submenu.indexOf(subitem) -
        this.currentItem.submenu.indexOf(this.currentSubitem)
      )
    },
  },
}
</script>

<style scoped>
.c-stepList {
  margin-top: -0.75rem;
}

.c-stepList__item-link {
  color: var(--v-navy-base) !important;
  transition: all 200ms;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

a.c-stepList__item-link:not(.c-stepList__item--active):hover {
  color: var(--v-navy-lighten1) !important;
}

.c-stepList__num {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: white;
  font-size: 11px;
  color: var(--v-navy-base);
  border: 1px solid var(--v-navy-base);
  border-radius: 50%;
  font-weight: 600;
}

.c-stepList__text {
  font-size: 12px;
  line-height: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03125rem;
}

.c-stepList__submenu {
  display: none;
  padding-left: 36px;
}

.c-stepList__submenu-item {
  display: block;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  position: relative;
  font-size: 14px;
  color: var(--v-navy-base) !important;
  line-height: 16px;
  transition: all 200ms;
}

a.c-stepList__submenu-item.is--active {
  font-weight: 600;
  color: var(--v-primary-base) !important;
}

a.c-stepList__submenu-item:not(.is--active):hover {
  color: var(--v-navy-lighten1) !important;
}

.c-stepList__submenu-item::before {
  content: "";
  display: none;
  width: 16px;
  height: 16px;
  background: url("../../assets/ico-arrow-right-gray.svg") center / contain
    no-repeat;
  position: absolute;
  right: -18px;
}

.c-stepList__submenu-item.is--active::before {
  display: block;
}

.c-stepList__item--done .c-stepList__text {
  color: var(--v-navy-lighten1);
}

.c-stepList__item--done .c-stepList__num {
  background: var(--v-green-lighten1)
    url("../../assets/ico-checkmark-white.svg") center / 10px 8px no-repeat;
  color: transparent;
  border: 1px solid var(--v-green-lighten1);
}

.c-stepList__item--active .c-stepList__text {
  color: var(--v-navy-darken1);
}

.c-stepList__item--active .c-stepList__num {
  background: var(--v-navy-darken1);
  color: white;
  border: 1px solid var(--v-navy-darken1);
}

.c-stepList__item--active .c-stepList__submenu {
  display: block;
}
</style>
